import CodeEditor from '@/components/code-editor/code-editor.vue';

export default {
  name: 'ScriptPackAddScript',
  components: {
    CodeEditor,
  },
  data: () => ({
    selected: null,
    scriptPackName: '',
    scriptType: null,
    scriptContext: null,
    scriptTypeOptions: [],
    scriptContextOptions: [],
    selectOptions: {},
  }),
  props: {
    scriptPackId: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.selectOptions = {
      booking: {
        contexts: {
          validate: {},
          created: {},
          updated: {},
          deleted: {},
        },
        name: 'Bookings',
      },
      cron: {
        contexts: {
          daily: {},
          hourly: {},
          weekly: {},
        },
        name: 'Periodic Tasks',
      },
    };
    const keys = Object.keys(this.selectOptions);
    this.scriptTypeOptions = [];
    for (let i = 0; i < keys.length; i += 1) {
      this.scriptTypeOptions.push({
        value: keys[i],
        text: this.selectOptions[keys[i]].name,
      });
    }
  },
  methods: {
    save(content) {
      const script = {
        scriptName: this.scriptPackName,
        scriptType: this.scriptType,
        scriptContext: this.scriptContext,
        content,
      };
      console.log('ScriptPacksEditor', script);
    },
    populatedOptions() {

    },
    setContextOptions() {
      const keys = Object.keys(this.selectOptions[this.scriptType].contexts);
      this.scriptContextOptions = [];
      for (let i = 0; i < keys.length; i += 1) {
        this.scriptContextOptions.push({
          value: keys[i],
          text: keys[i],
        });
      }
    },
  },
};
